import { MenuItem, Typography } from '@mui/material';
import { useDialog } from 'apps/app/src/hooks/use-dialog';
import { ShareInvoiceToSlackDialog } from './ShareInvoiceToSlackDialog';

type MenuItemShareInvoiceToSlackProps = {
  invoiceId: string;
};

export const MenuItemShareInvoiceToSlack: React.FC<
  MenuItemShareInvoiceToSlackProps
> = ({ invoiceId }) => {
  const { isDialogOpen, handleOpen, handleClose } = useDialog();

  return (
    <>
      <MenuItem
        className="pb-2"
        onClick={handleOpen}
      >
        <Typography>Share to Slack</Typography>
      </MenuItem>
      
      <ShareInvoiceToSlackDialog
        open={isDialogOpen}
        onClose={handleClose}
        invoiceId={invoiceId}
      />
    </>
  );
};
